import React, { useState } from 'react'; // Add useState
import logo from '../../assets/logo/vulli_narayana_tuitions_logo.png';
import { Link } from 'react-router-dom';

const Header = ({onRegisterClick}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="main-header">
      <div className="container header-flex">
        <div className="logo-section">
          <Link to="/" className="logo-link">
            <img 
              src={logo} 
              alt='header-logo' 
              className='header-logo' 
            />
            <div className='logo-text-container'>
              <h3 className='logo-text'>Vulli Narayana Tuitions</h3>
              <p className='logo-sub-text'>Class 1 to 10 & Inter</p>
            </div>
          </Link>
        </div>
        
        {/* Mobile Toggle Button */}
        <button className="mobile-menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <span className={`hamburger ${isMenuOpen ? 'open' : ''}`}></span>
        </button>

        <div className={`nav-actions-wrapper ${isMenuOpen ? 'active' : ''}`}>
          <nav className="desktop-nav">
            <a href="#courses" onClick={() => setIsMenuOpen(false)}>Courses</a>
            <a href="#about" onClick={() => setIsMenuOpen(false)}>Why Us?</a>
            <a href="#skills" onClick={() => setIsMenuOpen(false)}>Skills</a>
            <a href="#locations" onClick={() => setIsMenuOpen(false)}>Locations</a>
          </nav>

          <div className="header-actions">
            <a href="tel:9700213084" className="nav-phone">9700213084</a>
            <button className="btn-primary-header" onClick={() => { onRegisterClick(); setIsMenuOpen(false); }}>
              Register Now
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;